/** ADR-024 D6 — Customer Web indexable public routes */

export const SEO_DECISION_ID = 'ADR-024';

export const CUSTOMER_SITE_NAME = 'BeatQ Eats';
export const CUSTOMER_DEFAULT_TITLE = 'BeatQ Eats | Food, grocery & more nearby';
export const CUSTOMER_DEFAULT_DESCRIPTION =
  'Order delivery or collection from local restaurants, grocery, pharmacy, and stores near you.';

/** Reachable without an access token — unauthenticated browsing (ADR-024 sixth force). */
export const CUSTOMER_UNAUTHENTICATED_PREFIXES = [
  '/landing',
  '/sign-in',
  '/register',
  '/password-reset',
  '/password-reset-request',
  '/reset-password',
  '/verify-email',
  '/verify-mobile',
  '/two-factor-challenge',
  '/handover',
  '/home',
  '/out-of-area',
  '/vertical-listing',
  '/all-branches',
  '/search',
  '/search-results',
  '/zero-results',
  '/filters',
  '/category-browse',
  '/store',
  '/branch',
  '/branch-page',
  '/branch-information',
  '/branch-reviews',
  '/product-detail',
  '/modifier-group',
  '/allergen-information',
  '/product-unavailable',
  '/age-restricted-item',
  '/pharmacy-item-guidance',
  '/branch-closed',
  '/fulfilment-switcher',
  '/schedule-picker',
  '/offers',
  '/help-centre',
  '/legal',
  '/cookie-preferences',
  '/basket',
  '/checkout',
  // Exact prefixes — `/basket` does not match `/basket-conflict` (prefix needs `/basket/`).
  '/basket-conflict',
  '/basket-revalidation',
  '/minimum-not-met',
  '/not-found',
  '/maintenance',
  '/offline',
] as const;

/** Included in sitemap.xml and default to index,follow. */
export const CUSTOMER_INDEXABLE_ROUTES = [
  '/landing',
  '/home',
  '/all-branches',
  '/search',
  '/category-browse',
  '/offers',
  '/help-centre',
  '/legal',
] as const;

/** Always noindex — account, checkout, orders, auth flows, token handover. */
export const CUSTOMER_NOINDEX_PREFIXES = [
  '/account-',
  '/profile',
  '/security-settings',
  '/communication-preferences',
  '/privacy-and-data',
  '/close-account',
  '/address-',
  '/add-address',
  '/delivery-instructions',
  '/out-of-area',
  '/wallet',
  '/payment-',
  '/my-',
  '/checkout',
  '/basket',
  '/order-',
  '/sign-in',
  '/register',
  '/password-',
  '/reset-password',
  '/verify-',
  '/two-factor',
  '/handover/',
  '/notification-inbox',
  '/error',
] as const;

export const CUSTOMER_ROUTE_SEO: Record<
  string,
  { title: string; description?: string; indexable?: boolean }
> = {
  '/landing': {
    title: CUSTOMER_DEFAULT_TITLE,
    description: CUSTOMER_DEFAULT_DESCRIPTION,
    indexable: true,
  },
  '/home': {
    title: 'Browse restaurants & stores near you | BeatQ Eats',
    description:
      'Discover featured restaurants, grocery, pharmacy, and local stores for delivery or collection in your area.',
    indexable: true,
  },
  '/all-branches': {
    title: 'All branches | BeatQ Eats',
    description: 'Browse every BeatQ Eats partner branch in your area.',
    indexable: true,
  },
  '/search': {
    title: 'Search | BeatQ Eats',
    description: 'Search menus, branches, and cuisines.',
    indexable: true,
  },
  '/help-centre': {
    title: 'Help centre | BeatQ Eats',
    description: 'Answers to common ordering and account questions.',
    indexable: true,
  },
  '/legal': {
    title: 'Legal | BeatQ Eats',
    description: 'Terms, privacy, and regulatory information.',
    indexable: true,
  },
};
